"use client";

import { Button } from "@/components";
import { getImageURL } from "@/lib";

export const HomePageSustain = ({ data = {}, slug = "sustain-&-reliable" }) => {
    const { description, image, title, button } = data;

    return (
        <section className="sustain__section" id={slug}>
            <div className="custom-container">
                <div className="row align-items-center">
                    <div className="col">
                        <div className="img__wrap">
                            <div className="circle lg__circle" />
                            <div className="circle sm__circle" />
                            <img
                                className="img-fluid"
                                src={getImageURL(image?.src)}
                                alt={image?.alt || "default alt text"}
                            />
                        </div>
                    </div>
                    <div className="col-12 col-lg-4 col-xl-4">
                        <div className="section_header">
                            <h3
                                className="heading fs-48 fw-300"
                                dangerouslySetInnerHTML={{
                                    __html: title,
                                }}
                            />
                        </div>
                        <div className="content__wrap">
                            <p
                                className=""
                                dangerouslySetInnerHTML={{
                                    __html: description,
                                }}
                            />
                        </div>
                        <div className="btn-group">
                            {button?.map((item, index) => (
                                <Button
                                    key={index}
                                    label={item?.cta?.title}
                                    href={item?.cta?.url || "#"}
                                />
                            ))}
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};
